export enum GenericErrorCodes {
  "FIELD_REQUIRED" = "FIELD REQUIRED",
  "INVALID_STRING" = "INVALI STRING",
  "INVALID_NUMBER" = "INVALID NUMBER",
  "MINIMUM_CHARACTERS_NOT_MET" = "MINIMUM CHARACTERS NOT MET",
}
